var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/contextMenuItemAccount.scss';
import React, { forwardRef } from 'react';
import { Size } from '@front/sharedcomponents/Variables';
import { Style, StyleContext, StyleState } from '../../../Style';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { Typography } from '../../Typography/Typography';
import { InstrumentTypeLogo } from '../../InstrumentTypeLogo/InstrumentTypeLogo';
import { AccountTypeLogo } from '../../AccountTypeLogo/AccountTypeLogo';
export const ContextMenuItemAccount = forwardRef((_a, ref) => {
    var { accountName, accountMode, hasInstrumentTypeOffset, instrumentType, size = Size.Medium, disabled = false, checked = false, onClick, role = 'menuitem', styleClassName } = _a, restProps = __rest(_a, ["accountName", "accountMode", "hasInstrumentTypeOffset", "instrumentType", "size", "disabled", "checked", "onClick", "role", "styleClassName"]);
    const handleKeyDown = (e) => {
        if (disabled) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    const classNames = [
        'context-menu-item-account',
        size,
        Style.Secondary,
        StyleContext.ListItem,
        disabled ? StyleState.Disabled : '',
        checked ? StyleState.Checked : '',
        styleClassName
    ];
    const className = classNames.filter(Boolean).join(' ');
    return (React.createElement("li", Object.assign({ ref: ref, tabIndex: disabled ? -1 : 0, onClick: onClick, onKeyDown: handleKeyDown, className: className, role: role, "aria-disabled": disabled, "aria-label": accountName }, restProps),
        React.createElement(AccountTypeLogo, { accountType: accountMode, size: size }),
        hasInstrumentTypeOffset && React.createElement(InstrumentTypeLogo, { instrumentType: instrumentType, size: size }),
        React.createElement(Typography, { level: TypographyLevel.BodyMd, noWrap: true }, accountName)));
});
